import { render, staticRenderFns } from "./AcademicTrainingList.vue?vue&type=template&id=65024401"
import script from "./AcademicTrainingList.vue?vue&type=script&lang=js"
export * from "./AcademicTrainingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports